import React, { useCallback, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Icon from 'components/Icon';

import styles from './styles.module.scss';

const Search = ({
	isOpen = true,
	onEnter,
	onRequestClose,
	onChange,
	value = '',
	placeholder = 'Введите поисковый запрос',
	theme,
	onReset,
	hasClear = false,
	focusOnOpen = false
}) => {
	const inputRef = useRef(null);

	useEffect(() => {
		let cleanup;

		if (isOpen) {
			const onKeydown = (event) => {
				if (event.key === 'Escape') {
					onRequestClose?.();
				}
			};

			window.addEventListener('keydown', onKeydown);

			cleanup = () => window.removeEventListener('keydown', onKeydown);
		}

		return cleanup;
	}, [isOpen, onRequestClose]);

	const onClick = useCallback(
		(event) => {
			event.preventDefault();
			onEnter?.(inputRef.current.value);
		},
		[onEnter]
	);

	useEffect(() => {
		if (inputRef.current && focusOnOpen) {
			if (isOpen) {
				inputRef.current.focus();
			} else {
				inputRef.current.blur();
			}
		}
	}, [isOpen, focusOnOpen]);

	return (
		<form
			className={cx(styles.Search, styles[`Search_theme_${theme}`])}
			onSubmit={onClick}
		>
			{theme === 'header' && (
				<Icon icon="search" className={styles.Search__PlaceholderIcon} />
			)}
			<input
				onChange={onChange}
				className={styles.Search__Input}
				placeholder={placeholder}
				ref={inputRef}
				value={value}
			/>
			{theme !== 'header' && (
				<button
					aria-label="Поиск"
					className={styles.Search__Button}
					type="submit"
				>
					<span className={styles.Search__IconWrapper}>
						<Icon icon="search" className={styles.Search__Icon} />
					</span>
				</button>
			)}
			{hasClear && (
				<button
					aria-label="Поиск"
					className={styles.Search__Clear}
					type="button"
					title="Очистить"
					onClick={onReset}
				>
					<span className={styles.Search__IconWrapper}>
						<Icon icon="close" className={styles.Search__ClearIcon} />
					</span>
				</button>
			)}
		</form>
	);
};

Search.propTypes = {
	isOpen: PropTypes.bool,
	onEnter: PropTypes.func,
	onRequestClose: PropTypes.func,
	onChange: PropTypes.func,
	theme: PropTypes.oneOf(['simple', 'header']),
	placeholder: PropTypes.string,
	value: PropTypes.string,
	onReset: PropTypes.func,
	hasClear: PropTypes.bool,
	focusOnOpen: PropTypes.bool
};

export default Search;
